var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-gray-400 rounded-3xl sm:grid sm:grid-cols-4 sm:gap-4 p-4"},[_c('account-setting-menu'),_c('router-view',{staticClass:"col-span-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }